import { render } from "./AdminPersonalSearch.vue?vue&type=template&id=923958a6&scoped=true"
import script from "./AdminPersonalSearch.vue?vue&type=script&lang=js"
export * from "./AdminPersonalSearch.vue?vue&type=script&lang=js"

import "./AdminPersonalSearch.vue?vue&type=style&index=0&id=923958a6&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/drk-hurricane.de/test-helfer.drk-hurricane.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923958a6"]])

export default __exports__